import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Vessel, VesselsService } from '../../vessels.service';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentReference, DocumentService } from 'src/app/documents/documents.service';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { saveAs } from 'file-saver';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { MaterialSlideshowComponent } from 'src/app/shared/components/material-slideshow/material-slideshow.component';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MatSelectModule } from '@angular/material/select';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatIconModule } from '@angular/material/icon';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { Versioned } from 'src/app/shared/helpers/versioned';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

@Component({
  selector: 'app-vessel-information',
  templateUrl: './vessel-information.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    AuthenticationModule,
    MaterialSlideshowComponent,
    MaterialChunkFileUploadComponent,
    MatSelectModule,
    MaterialDateRangeComponent,
    MatIconModule,
    MaterialOrganisationSelectorComponent,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MaterialAutoCompleteComponent
  ]
})
export class VesselInformationComponent implements OnInit {
  title = new EventEmitter<string>();
  fileId!: string;
  versionedVessel!: Versioned<Vessel>;
  newItem!: boolean;
  role!: boolean;
  disabled!: boolean;
  currentFiles: FileList | null = null;
  currentForms: FileList| null = null;
  uploadedFileId!: string;
  selectedDocumentType!: string;
  endDateForCurrentPeriod: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  issueDate = {
    startDate: new Date(),
    endDate: new Date(),
  };
  type!: string;
  index!: number;
  slideShowType = MaterialSlideshowComponent;
  slideShow!: MaterialSlideshowComponent;
  removeFileId!: string;
  newName!: string;
  flags: Organisation[] = [];
  flag!: Organisation;
  q88FileId!: string;
  doc?: DocumentReference;
  doc2?: DocumentReference;
  types: string[] = ['Form C', 'Q88'];
  constructor(
    private _router: Router,
    private _activateRoute: ActivatedRoute,
    private _vesselsService: VesselsService,
    private _documentService: DocumentService,
    private _keycloakService: KeycloakService,
    private _documentsService: DocumentService,
    private _organisationService: OrganisationService,
    private _pgMessagesService: PgMessagesService,
  ) { }

  ngOnInit(): void {
    this._activateRoute.params.subscribe((params) => {
      const imo = params['imo'];
      if (imo) {
        forkJoin([
          this._vesselsService.getVessel(imo),
          this._organisationService.get()
        ]).subscribe((result) => {
          this.versionedVessel = result[0];
          this.title.emit(`Information ${this.versionedVessel?.data?.name?.name}`);
          this.versionedVessel.data!.documents = result[0]!.data!.documents
            .filter(d => !d.isDeleted)
            .sort((d1, d2) => d2.issueDate - d1.issueDate);
          this.versionedVessel.data!.previousNames = result[0]!.data!.previousNames.sort((n1, n2) => n2.from - n1.from);
          this.flags = result[1].filter(x => x.properties['country'] === true);
        });
      }
    });
  }

  hasRole(roleName: string) {
    if (this._keycloakService.hasRole(roleName)) {
      return this.role = true;
    } else {
      return this.role = false;
    }
  }

  downloadForm(type: string) {
    if (this.versionedVessel) {
      const link = this.versionedVessel.data!.documents?.filter(doc => doc.documentType === type);
      if (link.length > 0) {
        this._documentService.download(link[0].documentId).subscribe(f => {
          saveAs(f.body, `${this.versionedVessel.data!.name!.name}_${type}.pdf`);
        });
      }
    }
  }

  deleteMode(id: string) {
    const b = this.versionedVessel.data!.spec!.photoIds.indexOf(id);
    if (confirm('Are you sure you want to delete this Photo?')) {
      this.versionedVessel.data!.spec!.photoIds.splice(b, 1);
      this.onSubmit();
    }
  }

  uploadForm(form: DocumentReference) {
    const documents = {
      documentType: this.type,
      documentId: form.id,
      issueDate: this.issueDate.startDate.getTime()
    };
    this.versionedVessel!.data!.documents.push(documents);
    this.currentForms = null;
  }

  changeName() {
    if (!this.versionedVessel!.data!.previousNames) {
      this.versionedVessel.data!.previousNames = [];
    } else {
      const temp = this.versionedVessel.data!.name;
      this.versionedVessel.data!.previousNames.push(temp!);
    }
    this.versionedVessel.data!.name!.from = this.endDateForCurrentPeriod.startDate.getTime();
    this.versionedVessel.data!.name!.flag = this.flag.name;
    this.versionedVessel.data!.name!.name = this.newName;
    this.onSubmit();
  }

  onSubmit() {
    this._vesselsService.updateVessel(this.versionedVessel).subscribe(
      (s) => {
        this.versionedVessel = s;
        // this.versionedVessel.version.documents = s.documents
        //   .filter(d => !d.isDeleted)
        //   .sort((d1, d2) => d2.issueDate - d1.issueDate);
        // this.versionedVessel.data.previousNames = s.previousNames.sort((n1, n2) => n2.from - n1.from);
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Info,
          topic: 'Vessel',
          message: `The vessel ${this.versionedVessel!.data!.imo} information edited.`,
        });
        this._router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this._router
              .navigate([
                'vessels/vessel-information/',
              this.versionedVessel.data!.imo
              ])
              .then();
          });
      },
      () => {
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Error,
          topic: 'Vessel',
          message: 'There is a problem to add this vessel.',
        });
      }
    );

  }

  savePhoto(docReference: DocumentReference) {
    this.fileId = docReference.id;
    if (this.versionedVessel.data!.spec!.photoIds === undefined) {
      this.versionedVessel.data!.spec!.photoIds = [];
      this.versionedVessel.data!.spec!.photoIds[0] = this.fileId;
    } else {
      const a = this.versionedVessel.data!.spec!.photoIds.length;
      this.versionedVessel.data!.spec!.photoIds[a] = this.fileId;
    }
    this.currentFiles = null;
  }

  downloadDocumentId(id: string) {
    const a = id.split('/').slice(-1)[0];
    this._documentsService.download(a).subscribe(b => {
      saveAs(b.body, `${this.versionedVessel.data!.name!.name}.jpg`);
    },
    () => {
      this._pgMessagesService.publishMessage({
        message: 'Could not download this file.',
        level: MessageLevel.Error,
        topic: 'Voyage document'
      });
    });
  }

  downloadformId(id: string, type: string) {
    this._documentService.download(id).subscribe(b => {
      saveAs(b.body, `${this.versionedVessel.data!.name!.name}_${type}.pdf`);
    }, () => {
      this._pgMessagesService.publishMessage({
        message: 'Could not download this file.',
        level: MessageLevel.Error,
        topic: 'Voyage document'
      });
    });
  }

  removeDocument(id: string) {
    if (confirm('Are you sure you want to delete the document?')) {
      this.versionedVessel.data!.documents.find(d => d.documentId === id)!.isDeleted = true;
      this.onSubmit();
    }
  }
  typeFormatter(type: string): string {
    return type ?? '';
  }
}
